import React, { useState, useEffect, useMemo } from "react";
import { Select, Modal, message, Spin, Form } from "antd";
// import CategoryForm from "./CategoryForm";
import { LoadingOutlined } from "@ant-design/icons";
import StAddNew from "../../pages/DSeries/StAddNew";
import liracrypt from "../../components/Liracrypt/liracrypt";

const LinePopup = ({
  extraData = {},
  auxFunctions = {},
  refreshLineDashboard = () => { },
  setPopupEnabled = () => { },
  selectedLid,
}) => {

  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [visible, setVisible] = useState(false);
  const [complianceData, setComplianceData] = useState(null);
  const [form] = Form.useForm();
  const [modalTitle, setModalTitle] = useState("");
  // const [displayLoader, setDisplayLoader] = useState(false);
  // const [data, setData] = useState({ data: null, loading: false });
  // const options = null;

  const [loading, setLoading] = useState(false);

  const getData = () => {
    if (!visible) {
      setLoading(true);
    }
    liracrypt.get(auxFunctions?.config?.api, { lid: selectedLid, ...extraData, ...auxFunctions?.config?.params })
      .then(response => {
        if (!visible) {
          if (response.data.data) {
            setVisible(true);
            setPopupEnabled(true);
          }
          setComplianceData(response.data.data)
          setLoading(false);
        }
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      });
  }

  const handleOk = (e) => {
    setVisible(false);
    setPopupEnabled(false);
  };
  const handleCancel = (e) => {
    form.resetFields();
    setVisible(false);
    setPopupEnabled(false);
    setComplianceData(null)
  };

  useEffect(() => {
    getData();
    let interval = setInterval(() => {
      getData();
    }, auxFunctions?.config?.interval);
    return () => clearInterval(interval);
  }, [auxFunctions?.config?.interval]);

  return (
    <>
      <Modal
        title={modalTitle}
        maskClosable={false}
        open={visible}
        className={"ThemeModal"}
        closable={complianceData?.hideCloseBtn ? false : true}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{ disabled: true, hidden: true }}
        cancelButtonProps={{ disabled: true, hidden: true }}
      >
        {loading ? (
          <div className="Loading">
            <Spin indicator={antIcon} />
          </div>
        ) : (
          <div>
            <p style={complianceData?.style}>
              {complianceData?.msg}
              {/* <br />
              <span style={{fontSize: 10}}>{complianceData?.dt}</span> */}
            </p>
            <StAddNew
              initForm={form}
              setSmodalTitle={(title) => setModalTitle(title)}
              colSpan={24}
              urlEndpoint={complianceData?.smodal?.urlEndpoint}
              extraData={{ lid: selectedLid, ...extraData }}
              urlData={{ _id: complianceData?._id, lid: selectedLid, ...extraData, ...complianceData?.smodal?.urlData, dictName: complianceData?.smodal?.dictName }}
              // dictName={complianceData?.smodal?.dictName}
              submitTxt="Save"
              onCallFinish={() => {
                handleCancel();
                refreshLineDashboard();
                // setTimeout(() => {
                //   getData();
                // }, 2000);
              }}
            />
          </div>
        )}
      </Modal>
    </>
  );
};

export default LinePopup;
